import { DomainEvent, MessageName } from "@lookiero/messaging";
import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import { isScreenFilled } from "../../../../domain/screen/model/screenFilled";
import { NextBestActionDefinitionProjection } from "../../../../projection/nextBestActionDefinition/nextBestActionDefinition";
import { viewStyleProfileNextBestActionDefinitionByCustomerId } from "../../../../projection/nextBestActionDefinition/viewStyleProfileNextBestActionDefinitionByCustomerId";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewStyleProfileNextBestActionDefinitionByCustomerIdFunctionArgs {
  readonly customerId: string;
}

interface UseViewStyleProfileNextBestActionDefinitionByCustomerIdFunction {
  (
    args: UseViewStyleProfileNextBestActionDefinitionByCustomerIdFunctionArgs,
  ): UseQueryFunctionResult<NextBestActionDefinitionProjection>;
}

const shouldInvalidate = (event: DomainEvent<MessageName>) => isScreenFilled(event);

const useViewStyleProfileNextBestActionDefinitionByCustomerId: UseViewStyleProfileNextBestActionDefinitionByCustomerIdFunction =
  ({ customerId }) =>
    useQuery({
      query: viewStyleProfileNextBestActionDefinitionByCustomerId({ customerId }),
      contextId: MESSAGING_CONTEXT_ID,
      invalidation: shouldInvalidate,
      invalidationDelay: 600,
      options: {
        staleTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
      },
    });

export { useViewStyleProfileNextBestActionDefinitionByCustomerId };
